import CodeDefinitions from './CodeDefinitions';

export default CodeDefinitions;



// WEBPACK FOOTER //
// ./src/pages/static/CodeDefinitions/index.jsx